<template>
  <form-wrapper :validator="$v.danovnik">
    <b-form-row>
      <b-col style="padding-right: 0;">
        <b-form-group
          input-cols="7"
          :label="$t('message.lblRok')">
          <b-form-input
            value="2020"
            plaintext
          />
        </b-form-group>

        <b-form-group
          input-cols="7"
          name="type"
          class="required"
          :label="$t('message.lblTyp')">
          <template slot-scope="{ attrs, listeners }">
            <b-form-radio-group
              class="select-form"
              v-bind="attrs"
              v-model="danovnik.type"
              :options="foTypes"
              @input="
                danovnik.sk_nace = null,
                danovnik.prepojenie = null"
              plain
              v-on="listeners"/>
          </template>
        </b-form-group>

        <b-form-group
          input-cols="7"
          :label="$t('message.lblDruh')">
          <b-form-input
            :value="druh"
            plaintext/>
          <a
            style="cursor: pointer"
            v-if="danovnik.druh !== 3"
            @click="crDod(danovnik.id)">
            {{ $t('message.lblCreateDod') }}
          </a>
        </b-form-group>

        <b-form-group
          v-if="danovnik.druh === 3"
          :input-cols="7"
          :label="$t('message.lblDatumZistenia')"
          name="date_druh">
          <template slot-scope="{ attrs, listeners }">
            <date-picker
              v-bind="attrs"
              v-model="danovnik.date_druh"
              :language="sk"
              monday-first
              clear-button
              bootstrap-styling
              calendar-class="vdp-cal"
              format="dd.MM.yyyy"
              input-class="dp"
              v-on="listeners"/>
          </template>
        </b-form-group>

        <text-group
          :input-cols="7"
          :m="danovnik"
          name="dic"
          :align-right="false"
          :label="$t('message.lblDic')+' / '+ $t('message.lblRc')" />

        <transition name="fade">
          <b-form-group
            :label="$t('message.lblBirthday')"
            :input-cols="7"
            v-if="visibleNerezident"
            name="birthday">
            <template slot-scope="{ attrs, listeners }">
              <date-picker
                v-bind="attrs"
                v-model="danovnik.birthday"
                :language="sk"
                monday-first
                clear-button
                bootstrap-styling
                calendar-class="vdp-cal"
                format="dd.MM.yyyy"
                input-class="dp"
                v-on="listeners"/>
            </template>
          </b-form-group>
        </transition>

        <transition name="fade">
          <b-form-group
            :input-cols="7"
            :label="$t('message.lblNace')"
            v-if="visibleSkNace"
            name="sk_nace">
            <template slot-scope="{ attrs, listeners }">
              <b-form-select
                class="alignL"
                v-bind="attrs"
                v-model="danovnik.sk_nace"
                :options="$store.state.skNace"
                v-on="listeners"
              >
                <template slot="first">
                  <option :value="null">
                    {{ $t('message.msgSelect') }}
                  </option>
                </template>
              </b-form-select>
            </template>
          </b-form-group>
        </transition>

        <text-group
          :input-cols="7"
          v-for="(item, key) in textGroupItems.firstGroup"
          :key="key"
          :m="danovnik"
          :class="item.class"
          :name="key"
          :align-right="false"
          :label="item.label" />

        <b-form-group
          :label="$t('message.lblStat')"
          :input-cols="7"
          name="stat">
          <template slot-scope="{ attrs, listeners }">
            <b-form-select
              class="alignL"
              v-bind="attrs"
              v-model="danovnik.stat"
              @input="setNull"
              :options="$store.state.kraj"
              v-on="listeners" />
          </template>
        </b-form-group>

        <transition name="fade">
          <fieldset v-if="!selectedSk">
            <legend
              style="
                font-size:98%;
                color: black;
                margin-bottom:1em;
                text-align:left;">
              {{ $t('message.lblAdresaPobytu') }}
            </legend>

            <text-group
              :input-cols="7"
              v-for="(item, key) in textGroupItems.zastGroup"
              :key="key"
              :m="danovnik"
              :align-right="false"
              :name="key"
              :label="item.label" />

          </fieldset>
        </transition>

        <text-group
          :input-cols="7"
          v-for="(item, key) in textGroupItems.secondGroup"
          :key="key"
          :class="item.class"
          :m="danovnik"
          :align-right="item.alignRight"
          :name="key"
          :label="item.label" />

        <b-form-group
          :input-cols="7"
          class="required"
          :label="$t('message.lblPocPril')"
          name="pocet_priloh">
          <template slot-scope="{ attrs, listeners }">
            <b-input-group style="align-items: center">
              <b-form-input
                style="height:2.5em"
                v-bind="attrs"
                @input="danovnik.pocet_priloh = danovnik.pocet_priloh.toString().replace(',', '.')"
                v-model.trim="$v.danovnik.pocet_priloh.$model"
                v-on="listeners"/>
              <b-input-group-append>
                <b-btn
                  v-b-modal.prilohInfo
                  style="background-color: #e9ecef; border-color: #ced4da; height:2.8em;">
                  <img src="@/assets/info.png">
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </template>
        </b-form-group>

        <b-form-group
          :input-cols="7"
          :label="$t('message.lblDatumVyhlasenia')"
          name="datum_vyhlasenia">
          <template slot-scope="{ attrs, listeners }">
            <date-picker
              v-bind="attrs"
              v-model="danovnik.datum_vyhlasenia"
              :language="sk"
              :placeholder="vyhlaseniaPlaceholder()"
              monday-first
              clear-button
              bootstrap-styling
              calendar-class="vdp-cal"
              format="dd.MM.yyyy"
              input-class="dp"
              v-on="listeners"
            />
          </template>
        </b-form-group>
      </b-col>

      <b-col class="checkboxes">
        <b-form-group
          name="dochodca"
          input-cols="8"
          label="">
          <template slot-scope="{ attrs, listeners }">
            <b-form-checkbox
              v-bind="attrs"
              v-model="danovnik.dochodca"
              :value="1"
              :unchecked-value="0"
              @change="danovnik.suma_dochodku = null"
              plain
              v-on="listeners">
              {{ $t('message.lblDochodca') }}
            </b-form-checkbox>
          </template>
        </b-form-group>

        <transition name="fade">
          <b-form-group
            :input-cols="8"
            v-if="danovnik.dochodca === 1"
            name="suma_dochodku"
            :label="$t('message.lblSumDoch')">
            <template slot-scope="{ attrs, listeners }">
              <b-form-input
                :placeholder="suma"
                v-bind="attrs"
                @input="
                danovnik.suma_dochodku = danovnik.suma_dochodku.toString().replace(',', '.')"
                v-model.trim="$v.danovnik.suma_dochodku.$model"
                v-on="listeners"/>
            </template>
          </b-form-group>
        </transition>

        <b-form-group
          name="bonus_splnam_podmienky"
          input-cols="8"
          label="">
          <template slot-scope="{ attrs, listeners }">
            <b-form-checkbox
              v-bind="attrs"
              v-model="danovnik.bonus_splnam_podmienky"
              :value="1"
              :unchecked-value="0"
              plain
              v-on="listeners">
              {{ $t('message.lblPandemicke') }}
            </b-form-checkbox>
          </template>
        </b-form-group>

        <b-form-group
          name="nerezident"
          input-cols="8"
          label="">
          <template slot-scope="{ attrs, listeners }">
            <b-form-checkbox
              style="align-items: baseline;"
              v-bind="attrs"
              v-model="danovnik.nerezident"
              @change="
                danovnik.birthday = null,
                danovnik.nerezident_prijmy = null,
                danovnik.nerezident_stat == null ? danovnik.nerezident_stat = 'BE' : null,
                $v.$reset()"
              :value="1"
              :unchecked-value="0"
              plain
              v-on="listeners">
              {{ $t('message.lblNerezident') }}
            </b-form-checkbox>
          </template>
        </b-form-group>

        <transition name="fade">
          <b-form-group
            input-cols="8"
            :label="$t('message.lblStatRez')"
            v-if="visibleNerezident"
            name="nerezident_stat">
            <template slot-scope="{ attrs, listeners }">
              <b-form-select
                class="alignL"
                v-bind="attrs"
                v-model="danovnik.nerezident_stat"
                :options="$store.state.zahKraj"
                v-on="listeners" />
            </template>
          </b-form-group>
        </transition>

        <transition name="fade">
          <b-form-group
            v-if="visibleNerezident"
            :label="$t('message.lblUhrnPrijm')"
            :input-cols="8">
            <b-input-group append="EUR">
              <b-form-input
                class="alignR"
                :state="uhrnState"
                aria-describedby="nerez"
                @input="danovnik.nerezident_prijmy = danovnik.nerezident_prijmy.replace(',', '.')"
                v-model.trim="$v.danovnik.nerezident_prijmy.$model"/>
            </b-input-group>
            <span
              style="color: #dc3545"
              v-if="!$v.danovnik.nerezident_prijmy.maxValue">
              Nesmie byť vyšší ako 99999999.99.
            </span>
          </b-form-group>
        </transition>

        <transition name="fade">
          <b-form-group
            input-cols="8"
            v-if="visibleSkNace"
            name="prepojenie"
            label="">
            <template slot-scope="{ attrs, listeners }">
              <b-form-checkbox
                v-bind="attrs"
                v-model="danovnik.prepojenie"
                :value="1"
                :unchecked-value="0"
                plain
                v-on="listeners">
                {{ $t('message.lblPrepojenie') }}
              </b-form-checkbox>
            </template>
          </b-form-group>
        </transition>

        <transition
          name="fade"
          mode="out-in">
          <bubble-message
            v-if="danovnik.prepojenie === 1"
            :message="$t('message.ekonomickeHelp')"
            :img="true"/>
        </transition>

      </b-col>
    </b-form-row>

    <b-button
      class="btn-primary"
      @click="save">
      {{ $t('message.lblSave') }}
    </b-button>
    <b-button
      v-if="danovnik.druh === 3"
      class="pull-right upCase"
      variant="danger"
      @click="del(danovnik.id)">
      {{ $t('message.lblDelete') }}
    </b-button>

    <b-modal
      id="prilohInfo"
      :ok-only="true"
      :ok-title="$t('message.butBack')">
      <priloh-info />
    </b-modal>
  </form-wrapper>
</template>

<script>
import datePicker from 'vuejs-datepicker'
import { sk } from 'vuejs-datepicker/dist/locale'
import { required, maxLength, minLength, decimal, numeric, email, minValue, maxValue } from 'vuelidate/lib/validators'
import bFormGroup from '@/components/form-group-col6'
import textGroup from '@/components/extractor/textGroup.vue'
import restEditor from '@/mixins/restEditor'
import bubbleMessage from '@/components/bubbleMessage.vue'
import { containsNumber } from '@/validators'
import prilohInfo from '@/components/prilohInfo.vue'

function danovnikData() {
  return {
    id: 19,
    type: 'b',
    year: null,
    druh: 1,
    date_druh: null,
    priezvisko: null,
    meno: null,
    rc: null,
    dic: null,
    sk_nace: '',
    hl_pr_cinnost: null,
    titul: null,
    titul_za: null,
    ulica: null,
    cislo: null,
    psc: null,
    obec: null,
    stat: null,
    tel: null,
    mail: null,
    cislo_uctu: null,
    kod_banky: null,
    iban: null,
    pocet_mesiacov_pp: null,
    pocet_priloh: null,
    dochodca: null,
    suma_dochodku: null,
    bonus_splnam_podmienky: null,
    nerezident: null,
    nerezident_stat: null,
    nerezident_prijmy: null,
    prepojenie: null,
    prech_ulica: null,
    prech_cislo: null,
    prech_psc: null,
    prech_obec: null,
    birthday: null,
    datum_vyhlasenia: null,
    date: ''
  };
}

export default {
  components: {
    bFormGroup,
    datePicker,
    textGroup,
    bubbleMessage,
    prilohInfo,
  },

  mixins: [restEditor],

  validations() {
    return {
      danovnik: {
        year: {},
        type: { required },
        dic: {
          dicNarodenia: (value, vm) => !(value && vm.birthday),
          required: this.danovnik.nerezident !== 1 ? required : true,
          maxLength: maxLength(11),
          minLength: minLength(9),
        },
        birthday: {
          dicNarodenia: (value, vm) => !(value && vm.dic),
        },
        sk_nace: {},
        priezvisko: { required, maxLength: maxLength(20), containsNumber },
        meno: { required, maxLength: maxLength(16), containsNumber },
        titul: { maxLength: maxLength(11), containsNumber },
        titul_za: { maxLength: maxLength(9), containsNumber },
        ulica: { maxLength: maxLength(28) },
        cislo: { maxLength: maxLength(8) },
        psc: { numeric, maxLength: maxLength(5) },
        obec: { maxLength: maxLength(20) },
        stat: {},
        prech_ulica: {
          maxLength: maxLength(28),
        },
        prech_cislo: {
          maxLength: maxLength(20),
        },
        prech_psc: {
          numeric,
          maxLength: maxLength(5),
        },
        prech_obec: {
          maxLength: maxLength(20),
        },
        tel: {
          maxLength: maxLength(15),
        },
        mail: {
          maxLength: maxLength(50),
          email,
        },
        iban: {
          maxLength: maxLength(34),
        },
        pocet_priloh: {
          numeric,
          required,
          minPriloh: this.danovnik.type === 'b' ? minValue(3) : minValue(1),
          maxValue: maxValue(99),
        },
        datum_vyhlasenia: {},
        dochodca: {},
        nerezident_prijmy: {
          decimal,
          minValue: minValue(0),
          maxValue: maxValue(99999999.99),
        },
        suma_dochodku: {
          decimal,
          minValue: minValue(0),
          maxValue: maxValue(99999999.99),
        },
        bonus_splnam_podmienky: {},
        nerezident: {},
        nerezident_stat: {},
        prepojenie: {},
        date: {}
      },
    };
  },

  data() {
    return {
      foTypes: [
        { value: 'a', text: 'a' },
        { value: 'b', text: 'b' }
      ],
      sknace: [],
      kraj: [],
      zahKraj: [],
      danovnik: danovnikData(),
      sk,
      prilohInfo: false,
      textGroupItems: {
        firstGroup: {
          priezvisko: { class: 'required', label: this.$t('message.lblPriez') },
          meno: { class: 'required', label: this.$t('message.lblMeno') },
          titul: { class: '', label: this.$t('message.lblTitulP') },
          titul_za: { class: '', label: this.$t('message.lblTitulZ') },
          ulica: { class: '', label: this.$t('message.lblUlica') },
          cislo: { class: '', label: this.$t('message.lblCislo') },
          psc: { class: '', label: this.$t('message.lblPsc') },
          obec: { class: '', label: this.$t('message.lblObec') },
        },
        zastGroup: {
          prech_ulica: { label: this.$t('message.lblUlica') },
          prech_cislo: { label: this.$t('message.lblCislo') },
          prech_psc: { label: this.$t('message.lblPsc') },
          prech_obec: { label: this.$t('message.lblObec') },
        },
        secondGroup: {
          tel: { label: this.$t('message.lblTel'), alignRight: false },
          mail: { label: this.$t('message.lblMail'), alignRight: false },
          iban: { label: this.$t('message.lblIban'), alignRight: false },
        },
      },
    };
  },

  computed: {
    druh() {
      return this.danovnik.druh === 3 ? this.$t('message.lblDodDanPriz') : this.$t('message.lblDanPriz');
    },
    visibleSkNace() {
      return this.$v.danovnik.type.$model === 'b';
    },
    visibleNerezident() {
      return this.$v.danovnik.nerezident.$model === 1;
    },
    selectedSk() {
      return this.danovnik.stat === 'SK';
    },
    suma() {
      if (this.danovnik.type === 'a') {
        return '5000.00';
      }
      return null;
    },
    uhrnState() {
      if (this.$v.danovnik.nerezident_prijmy.$dirty) {
        return !this.$v.danovnik.nerezident_prijmy.$invalid;
      }
      return null;
    },
  },

  methods: {
    async processGet() {
      this.danovnik = await this.restDataSource.getData(this.$route.params.userId, 'subjects');
      this.commitType(this.danovnik.type, this.danovnik.nerezident !== 1);
      if (this.danovnik.stat == null) {
        this.danovnik.stat = 'SK';
      }
      if (this.danovnik.nerezident_stat == null) {
        this.danovnik.nerezident_stat = 'BE';
      }
    },
    async processSave() {
      if (this.danovnik.dochodca !== 1) {
        this.danovnik.suma_dochodku = null;
      }
      this.danovnik.dic = this.danovnik.dic.replace('/', '');
      if ((this.danovnik.dochodca === 1) &&
          !this.danovnik.suma_dochodku) {
        this.danovnik.suma_dochodku = 5000;
      }

      if (this.danovnik.nerezident === 0) {
        this.danovnik.nerezident_stat = null;
      }

      await this.restDataSource.updateData(this.danovnik, 'subjects');
      this.commitType(this.danovnik.type, (this.danovnik.nerezident !== 1));
    },
    vyhlaseniaPlaceholder () {
      const now = this.danovnik.date

      const year = now.substring(0, 4)
      const month = now.substring(5, 7)
      const day = now.substring(8, 10)

      return day + '.' + month + '.' + year
    },
    commitType(type, nerezident) {
      this.$store.commit('setType', type);
      this.$store.commit('nerezident', nerezident);
    },
    setNull() {
      const element = this.danovnik;
      if (element.stat === 'SK') {
        element.prech_ulica = null;
        element.prech_cislo = null;
        element.prech_psc = null;
        element.prech_obec = null;
      }
    },
    async crDod(id) {
      const responseId = await this.restDataSource.crDod(id);
      this.$nextTick(() => {
        this.$router.push({ name: 'danovnik', params: { userId: responseId } });
        alert('Dodatočné daňové priznanie bolo vytvorené.');
        this.processGet();
      });
      return null;
    },
    async del(id) {
      await this.restDataSource.delDod(id);
      this.$router.push({ name: 'danovePriznanie' });
      alert('Dodatočné daňové priznanie bolo vymazané.');
    },
  },
};
</script>

<style>
.mx-clear-wrapper {
  padding: 0px !important;
}
.input-group-text {
  font-size: 0.8em;
}
#prilohInfo li {
  margin-top: 1em;
  margin-bottom: 1em;
}
.modal-dialog {
  max-width: 800px;
}

.checkboxes .form-check.form-check-inline input {
  margin-bottom: auto;
  margin-top: 3px;
}
</style>
